var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoConstructora(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188.919,
    height: 117.181,
    viewBox: "0 0 188.919 117.181",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #414042;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3 {\n        fill: #244b3e;\n      }\n\n      .cls-4 {\n        fill: #903120;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    className: "cls-1",
    width: 188.919,
    height: 117.181
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo_Constructora",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    className: "cls-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2693",
    "data-name": "Path 2693",
    className: "cls-3",
    d: "M24.435,16.6H73.6V59.114H29.693a5.206,5.206,0,0,1-5.258-5.152Zm100.1,0h-49V59.114h43.739a5.206,5.206,0,0,0,5.258-5.152Z",
    transform: "translate(20.021 13.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2694",
    "data-name": "Path 2694",
    className: "cls-4",
    d: "M73.6,0V28.3H24.435Zm1.934,0V28.3h49Z",
    transform: "translate(20.021 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2695",
    "data-name": "Path 2695",
    className: "cls-1",
    d: "M17.809,67.148a4.6,4.6,0,0,1-3.559,1.588,4.525,4.525,0,0,1-4.588-4.874,4.517,4.517,0,0,1,4.588-4.819,4.566,4.566,0,0,1,3.544,1.536l-.837.726A3.324,3.324,0,0,0,14.263,60c-1.923,0-3.393,1.536-3.393,3.864s1.47,3.932,3.393,3.932a3.432,3.432,0,0,0,2.749-1.332Z",
    transform: "translate(7.917 48.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2696",
    "data-name": "Path 2696",
    className: "cls-1",
    d: "M26.139,63.863a4.657,4.657,0,0,1-4.769,4.874,4.847,4.847,0,0,1,0-9.694,4.627,4.627,0,0,1,4.769,4.819m-8.327,0a3.583,3.583,0,1,0,7.132,0,3.577,3.577,0,1,0-7.132,0",
    transform: "translate(13.603 48.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2697",
    "data-name": "Path 2697",
    className: "cls-1",
    d: "M32.586,59.276v9.559h-.111l-6.017-6.7-.44-.553.042.675v6.313H24.934V59.006h.109l5.909,6.517.562.7L31.46,65.4V59.276Z",
    transform: "translate(20.43 48.347)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2698",
    "data-name": "Path 2698",
    className: "cls-1",
    d: "M35.464,59.043a3.742,3.742,0,0,1,2.982,1.279l-.742.688a2.625,2.625,0,0,0-2.2-1.05c-1.141,0-1.8.564-1.8,1.441,0,1.117,1.032,1.479,2.13,1.91,1.235.484,2.569,1.037,2.569,2.8,0,1.845-1.346,2.625-3.133,2.625a3.976,3.976,0,0,1-3.366-1.723l.811-.593a3.03,3.03,0,0,0,2.542,1.428c1.636,0,2.061-.875,2.061-1.7,0-1.157-1.017-1.561-2.1-1.992-1.25-.5-2.6-1.01-2.6-2.693,0-1.561,1.21-2.423,2.844-2.423",
    transform: "translate(26.142 48.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2699",
    "data-name": "Path 2699",
    className: "cls-1",
    d: "M44.7,59.154v.97H41.81v8.32H40.669v-8.32H37.744v-.97Z",
    transform: "translate(30.926 48.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2700",
    "data-name": "Path 2700",
    className: "cls-1",
    d: "M44.307,59.184c.633-.027,1.8-.067,2.474-.067,2.225,0,3.339,1,3.339,2.653a2.6,2.6,0,0,1-1.8,2.705l2.982,4H50L47.18,64.7c-.289.027-.537.04-.8.04a7.348,7.348,0,0,1-.962-.053v3.782H44.307Zm1.113,4.578a9.3,9.3,0,0,0,1.208.082c1.306,0,2.365-.513,2.365-1.981,0-.941-.428-1.83-2.172-1.83-.466,0-1.181.055-1.4.067Z",
    transform: "translate(36.303 48.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2701",
    "data-name": "Path 2701",
    className: "cls-1",
    d: "M51.649,64.675c0,2.032.81,3.042,2.5,3.042s2.514-1.01,2.514-3.042v-5.52h1.153v5.183c0,1.668-.22,4.308-3.682,4.308s-3.628-2.693-3.628-4.308V59.155h1.141Z",
    transform: "translate(41.384 48.469)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2702",
    "data-name": "Path 2702",
    className: "cls-1",
    d: "M65.725,67.148a4.6,4.6,0,0,1-3.559,1.588,4.525,4.525,0,0,1-4.588-4.874,4.517,4.517,0,0,1,4.588-4.819,4.566,4.566,0,0,1,3.544,1.536l-.837.726A3.327,3.327,0,0,0,62.179,60c-1.923,0-3.393,1.536-3.393,3.864s1.47,3.932,3.393,3.932a3.432,3.432,0,0,0,2.749-1.332Z",
    transform: "translate(47.177 48.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2703",
    "data-name": "Path 2703",
    className: "cls-1",
    d: "M71.335,59.154v.97H68.45v8.32H67.311v-8.32H64.383v-.97Z",
    transform: "translate(52.753 48.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2704",
    "data-name": "Path 2704",
    className: "cls-1",
    d: "M79.78,63.863a4.768,4.768,0,1,1-4.769-4.819,4.657,4.657,0,0,1,4.769,4.819m-8.327,0a3.583,3.583,0,1,0,7.132,0,3.577,3.577,0,1,0-7.132,0",
    transform: "translate(57.556 48.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2705",
    "data-name": "Path 2705",
    className: "cls-1",
    d: "M78.575,59.184c.633-.027,1.8-.067,2.474-.067,2.225,0,3.339,1,3.339,2.653a2.6,2.6,0,0,1-1.8,2.705l2.98,4h-1.3L81.448,64.7c-.289.027-.537.04-.8.04a7.32,7.32,0,0,1-.961-.053v3.782H78.575Zm1.113,4.578a9.3,9.3,0,0,0,1.208.082c1.306,0,2.365-.513,2.365-1.981,0-.941-.428-1.83-2.172-1.83-.468,0-1.181.055-1.4.067Z",
    transform: "translate(64.381 48.438)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2706",
    "data-name": "Path 2706",
    className: "cls-1",
    d: "M90.763,59.154v.97H86.257v3.029h3.764v.955H86.257v3.379h4.754v.957H85.116v-9.29Z",
    transform: "translate(69.741 48.468)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2707",
    "data-name": "Path 2707",
    className: "cls-1",
    d: "M94.136,59.043a3.742,3.742,0,0,1,2.982,1.279l-.742.688a2.625,2.625,0,0,0-2.2-1.05c-1.141,0-1.8.564-1.8,1.441,0,1.117,1.032,1.479,2.13,1.91,1.235.484,2.569,1.037,2.569,2.8,0,1.845-1.346,2.625-3.133,2.625a3.976,3.976,0,0,1-3.366-1.723l.811-.593a3.03,3.03,0,0,0,2.542,1.428c1.636,0,2.061-.875,2.061-1.7,0-1.157-1.017-1.561-2.1-1.992-1.25-.5-2.6-1.01-2.6-2.693,0-1.561,1.21-2.423,2.844-2.423",
    transform: "translate(74.215 48.377)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2708",
    "data-name": "Path 2708",
    className: "cls-1",
    d: "M7.727,62.132H0v-17.3H6.868a10.1,10.1,0,0,1,3.093.42,4.2,4.2,0,0,1,3.146,4.157,3.514,3.514,0,0,1-1.339,3.02,5.027,5.027,0,0,1-.631.433c-.118.058-.327.151-.631.284A4.667,4.667,0,0,1,13.119,54.6a3.987,3.987,0,0,1,.972,2.734,4.592,4.592,0,0,1-1.263,3.191q-1.465,1.61-5.1,1.61m-3.788-10.3H5.807a6.455,6.455,0,0,0,2.438-.346,1.456,1.456,0,0,0,.8-1.5,1.538,1.538,0,0,0-.733-1.523A5.9,5.9,0,0,0,5.833,48.1H3.939Zm0,7.028h2.7a6.1,6.1,0,0,0,2.538-.408,1.612,1.612,0,0,0,.846-1.61,1.543,1.543,0,0,0-.9-1.583,7.855,7.855,0,0,0-2.867-.384H3.939Z",
    transform: "translate(0 36.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2709",
    "data-name": "Path 2709",
    className: "cls-1",
    d: "M9.425,47.77a2.181,2.181,0,0,1,0-3.095,2.289,2.289,0,0,1,3.157,0,2.181,2.181,0,0,1,0,3.095,2.293,2.293,0,0,1-3.157,0M12.9,62.776H9.108V49.464H12.9Z",
    transform: "translate(7.195 36.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2710",
    "data-name": "Path 2710",
    className: "cls-1",
    d: "M24.73,58.507a7.68,7.68,0,0,1-5.393,2.127,7.247,7.247,0,0,1-5.114-1.867A6.5,6.5,0,0,1,12.2,53.755a6.4,6.4,0,0,1,2.058-5A7.021,7.021,0,0,1,19.123,46.9a7.117,7.117,0,0,1,4.761,1.657A5.651,5.651,0,0,1,25.84,53.11v1.981h-9.9A2.644,2.644,0,0,0,17.1,56.873a3.768,3.768,0,0,0,2.221.693,4.411,4.411,0,0,0,3.284-1.312Zm-3.637-7.894a2.9,2.9,0,0,0-1.907-.644,3.456,3.456,0,0,0-2.058.67,2.54,2.54,0,0,0-1.086,1.8H22a2.619,2.619,0,0,0-.908-1.83",
    transform: "translate(9.999 38.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2711",
    "data-name": "Path 2711",
    className: "cls-1",
    d: "M24.592,53.012v7.423H20.8V47.123h3.788v1.485A5.348,5.348,0,0,1,28.456,46.9a4.828,4.828,0,0,1,3.6,1.483A5.425,5.425,0,0,1,33.5,52.345v8.091H29.717V52.914q0-3.07-2.3-3.069a2.789,2.789,0,0,0-1.981.8,3.1,3.1,0,0,0-.846,2.363",
    transform: "translate(17.046 38.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2712",
    "data-name": "Path 2712",
    className: "cls-1",
    d: "M41.389,58.453A7.677,7.677,0,0,1,36,60.58a7.247,7.247,0,0,1-5.114-1.867A6.5,6.5,0,0,1,28.863,53.7a6.4,6.4,0,0,1,2.058-5,7.021,7.021,0,0,1,4.861-1.856A7.127,7.127,0,0,1,40.543,48.5,5.652,5.652,0,0,1,42.5,53.056v1.981H32.6a2.644,2.644,0,0,0,1.163,1.781,3.768,3.768,0,0,0,2.221.693A4.411,4.411,0,0,0,39.268,56.2Zm-3.637-7.894a2.9,2.9,0,0,0-1.907-.644,3.456,3.456,0,0,0-2.058.67,2.546,2.546,0,0,0-1.086,1.8H38.66a2.612,2.612,0,0,0-.908-1.83",
    transform: "translate(23.649 38.384)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2713",
    "data-name": "Path 2713",
    className: "cls-1",
    d: "M48.388,56.292a3.846,3.846,0,0,1-1.477,3.155,5.8,5.8,0,0,1-3.75,1.188A10.218,10.218,0,0,1,40,60.1a9.359,9.359,0,0,1-2.955-1.572L38.717,56.2a7.341,7.341,0,0,0,4.519,1.608,2.075,2.075,0,0,0,1.163-.284.868.868,0,0,0,.429-.755,1.088,1.088,0,0,0-.595-.866,6.836,6.836,0,0,0-1.716-.742q-1.124-.347-1.717-.593a9.657,9.657,0,0,1-1.352-.719,3.056,3.056,0,0,1-1.539-2.784,3.621,3.621,0,0,1,1.514-3.006A6.245,6.245,0,0,1,43.338,46.9a8.658,8.658,0,0,1,4.8,1.583l-1.414,2.474A6.3,6.3,0,0,0,43.2,49.771q-1.755,0-1.754.941a.907.907,0,0,0,.555.817,11.52,11.52,0,0,0,1.843.693q1.291.4,1.832.606a9.33,9.33,0,0,1,1.3.655,3.009,3.009,0,0,1,1.414,2.809",
    transform: "translate(30.357 38.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2714",
    "data-name": "Path 2714",
    className: "cls-1",
    d: "M68.283,62.132H60.556v-17.3h6.868a10.107,10.107,0,0,1,3.093.42,4.2,4.2,0,0,1,3.146,4.157,3.514,3.514,0,0,1-1.339,3.02,5.027,5.027,0,0,1-.631.433c-.118.058-.329.151-.633.284A4.666,4.666,0,0,1,73.675,54.6a4,4,0,0,1,.972,2.734,4.6,4.6,0,0,1-1.263,3.191q-1.466,1.61-5.1,1.61m-3.788-10.3h1.868A6.462,6.462,0,0,0,68.8,51.49a1.456,1.456,0,0,0,.8-1.5,1.541,1.541,0,0,0-.733-1.523,5.91,5.91,0,0,0-2.474-.371H64.495Zm0,7.028h2.7a6.1,6.1,0,0,0,2.538-.408,1.612,1.612,0,0,0,.846-1.61,1.542,1.542,0,0,0-.9-1.583,7.837,7.837,0,0,0-2.865-.384H64.495Z",
    transform: "translate(49.617 36.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2715",
    "data-name": "Path 2715",
    className: "cls-1",
    d: "M69.979,47.77a2.185,2.185,0,0,1,0-3.095,2.291,2.291,0,0,1,3.158,0,2.181,2.181,0,0,1,0,3.095,2.3,2.3,0,0,1-3.158,0m3.473,15.006H69.664V49.464h3.788Z",
    transform: "translate(56.812 36.087)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2716",
    "data-name": "Path 2716",
    className: "cls-1",
    d: "M85.285,58.507a7.683,7.683,0,0,1-5.393,2.127,7.244,7.244,0,0,1-5.114-1.867,6.5,6.5,0,0,1-2.019-5.012,6.4,6.4,0,0,1,2.058-5A7.022,7.022,0,0,1,79.68,46.9a7.108,7.108,0,0,1,4.758,1.657A5.647,5.647,0,0,1,86.4,53.11v1.981H76.5a2.644,2.644,0,0,0,1.163,1.781,3.77,3.77,0,0,0,2.223.693,4.41,4.41,0,0,0,3.282-1.312ZM81.65,50.613a2.915,2.915,0,0,0-1.909-.644,3.456,3.456,0,0,0-2.058.67,2.534,2.534,0,0,0-1.086,1.8h5.958a2.624,2.624,0,0,0-.906-1.83",
    transform: "translate(59.616 38.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2717",
    "data-name": "Path 2717",
    className: "cls-1",
    d: "M85.148,53.012v7.423H81.36V47.123h3.788v1.485A5.348,5.348,0,0,1,89.012,46.9a4.832,4.832,0,0,1,3.6,1.483,5.432,5.432,0,0,1,1.452,3.961v8.091H90.275V52.914q0-3.07-2.3-3.069a2.79,2.79,0,0,0-1.983.8,3.111,3.111,0,0,0-.846,2.363",
    transform: "translate(66.663 38.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2718",
    "data-name": "Path 2718",
    className: "cls-1",
    d: "M101.945,58.507a7.683,7.683,0,0,1-5.393,2.127,7.247,7.247,0,0,1-5.114-1.867,6.5,6.5,0,0,1-2.02-5.012,6.4,6.4,0,0,1,2.058-5A7.021,7.021,0,0,1,96.338,46.9a7.109,7.109,0,0,1,4.759,1.657,5.647,5.647,0,0,1,1.958,4.552v1.981h-9.9a2.644,2.644,0,0,0,1.163,1.781,3.768,3.768,0,0,0,2.221.693,4.411,4.411,0,0,0,3.284-1.312Zm-3.637-7.894a2.906,2.906,0,0,0-1.907-.644,3.456,3.456,0,0,0-2.058.67,2.534,2.534,0,0,0-1.086,1.8h5.958a2.618,2.618,0,0,0-.908-1.83",
    transform: "translate(73.267 38.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2719",
    "data-name": "Path 2719",
    className: "cls-1",
    d: "M108.944,56.292a3.846,3.846,0,0,1-1.477,3.155,5.8,5.8,0,0,1-3.75,1.188,10.218,10.218,0,0,1-3.157-.531,9.359,9.359,0,0,1-2.955-1.572L99.273,56.2a7.341,7.341,0,0,0,4.519,1.608,2.071,2.071,0,0,0,1.163-.284.868.868,0,0,0,.429-.755,1.09,1.09,0,0,0-.593-.866,6.883,6.883,0,0,0-1.717-.742q-1.124-.347-1.717-.593A9.656,9.656,0,0,1,100,53.854a3.056,3.056,0,0,1-1.539-2.784,3.621,3.621,0,0,1,1.514-3.006,6.245,6.245,0,0,1,3.915-1.163,8.658,8.658,0,0,1,4.8,1.583l-1.414,2.474a6.29,6.29,0,0,0-3.524-1.188q-1.755,0-1.754.941a.907.907,0,0,0,.555.817,11.591,11.591,0,0,0,1.843.693q1.288.4,1.832.606a9.43,9.43,0,0,1,1.3.655,3.009,3.009,0,0,1,1.414,2.809",
    transform: "translate(79.975 38.429)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2720",
    "data-name": "Path 2720",
    className: "cls-1",
    d: "M53.367,62.064a6.416,6.416,0,0,1-4.046-1.294,4.242,4.242,0,0,1-1.67-3.548q0-2.683,3.972-4.772a11.318,11.318,0,0,1-1.392-1.828,3.638,3.638,0,0,1-.4-1.8,3.371,3.371,0,0,1,1.43-2.92,5.641,5.641,0,0,1,3.368-1.021,5.514,5.514,0,0,1,3.295.972,3.174,3.174,0,0,1,1.355,2.731q0,2.35-3.875,4.439,1.938,2.328,3.149,3.56a8.594,8.594,0,0,0,1.163-2.54L61.7,55.418a15.6,15.6,0,0,1-1.43,2.873q.969.974,2.471,2.351L60.927,62.3,58.7,60.142a7.661,7.661,0,0,1-5.329,1.921m-2.107-2.978a4.035,4.035,0,0,0,2.447.677,5.323,5.323,0,0,0,3.246-1.377q-2.448-2.516-3.877-4.225-2.737,1.446-2.736,3.18a2.074,2.074,0,0,0,.921,1.745m3.355-12.1a2.305,2.305,0,0,0-1.454.5,1.45,1.45,0,0,0-.642,1.163,2.243,2.243,0,0,0,.327,1.2,13.479,13.479,0,0,0,1.126,1.485q2.737-1.329,2.738-2.469a1.63,1.63,0,0,0-.642-1.414,2.436,2.436,0,0,0-1.454-.462",
    transform: "translate(39.043 36.771)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoConstructora);
export default __webpack_public_path__ + "static/media/logo-constructora.4ce152906252f133381ab6619dac6678.svg";
export { ForwardRef as ReactComponent };